import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles({
  root: {
    // backgroundColor: '#1C3F94',
    background: 'radial-gradient(52.63% 300.89% at 49.31% 251.79%, #1891F6 0%, #15205E 100%);',
    color: '#fff',
    margin: '0 0 10px 0',
    height: '40px',
    padding: '0 10px',
  },
  appbarToolbar: {
    minHeight: '40px',
    padding: 0,
  },
  appLogo: {
    height: '22px',
  },
  logoDivider: {
    width: '1px',
    height: '100%',
    background: '#FFF',
    opacity: '0.2',
    margin: '0 8px 0 16px',
  },
  profileAvatar: {
    float: 'right',
    position: 'absolute',
    right: '20px',
    cursor: 'pointer',
  },
  profileImage: {
    float: 'right !important',
    position: 'absolute !important',
    right: '10px !important',
    width: '24px',
    height: '24px',
    lineHeight: '24px',
    fontSize: '0.8rem',
    border: 'solid 1px #999',
    borderRadius: '25px',
  },
}, { name: 'app-header' });
